import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'


class SearchByPartner extends Component {
    _handleChangePartner = async (field, value) => {
        await this.props.onChange('partners', value)
        this.props.onSubmit()
    }


    render() {
        const {filter, listPartner} = this.props
        const {partners} = filter

        const partnerOptions = listPartner.filter(i => i.name === "MC Lab").map(i=>({
            label: i.name,
            value:i._id,
         }))

        return (
            <div className="SearchByPartner mr-3 mb-2 d-flex flex-column">
                <label htmlFor="" className='mb-0 font-weight-bold'>Partner</label>
                <Select
                    allowClear
                    style={{ minWidth: '200px' }}
                    placeholder='Chọn partner sản xuất'
                    onChange={value => this._handleChangePartner('partners', value)}
                    options={partnerOptions}
                    value={partners ? partners: undefined}
                />   
            </div>
        )
    }
}

SearchByPartner.propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default SearchByPartner
